import { DevicesSection } from '../components/DevicesSection';
import { LogoutAllButton } from '../components/LogoutAllButton';
import { PasswordChangeForm } from '../components/PasswordChangeForm';
import { ProfileSection } from '../components/ProfileSection';
import { RecentActivitySection } from '../components/RecentActivitySection';

export function AccountPage() {
  return (
    <div className="space-y-10">
      <div className="max-w-2xl">
        <p className="text-[0.72rem] font-semibold uppercase tracking-[0.18em] text-emerald-800/95">
          Compte
        </p>
        <h2 className="mt-3 text-[1.875rem] font-semibold tracking-tight text-slate-900 sm:text-[2.05rem]">
          Profil et sessions
        </h2>
        <p className="mt-4 text-[0.95rem] leading-relaxed text-slate-600">
          Consultez vos informations personnelles, renforcez vos identifiants, gérez les appareils
          de confiance et surveillez l’activité liée à la sécurité.
        </p>
      </div>

      <div className="grid gap-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.95fr)] xl:gap-12">
        <div className="space-y-10">
          <ProfileSection />
          <PasswordChangeForm />
          <LogoutAllButton />
        </div>
        <div className="space-y-10">
          <DevicesSection />
          <RecentActivitySection />
        </div>
      </div>
    </div>
  );
}
